export default {
    "AD": {
        "name": "Andorra"
    },
    "AE": {
        "name": "Förenade Arabemiraten"
    },
    "AF": {
        "name": "Afghanistan"
    },
    "AG": {
        "name": "Antigua och Barbuda"
    },
    "AL": {
        "name": "Albanien"
    },
    "AM": {
        "name": "Armenien"
    },
    "AO": {
        "name": "Angola"
    },
    "AR": {
        "name": "Argentina"
    },
    "AT": {
        "name": "Österrike"
    },
    "AU": {
        "name": "Australien"
    },
    "AZ": {
        "name": "Azerbajdzjan"
    },
    "BA": {
        "name": "Bosnien och Hercegovina"
    },
    "BB": {
        "name": "Barbados"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BE": {
        "name": "Belgien"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BG": {
        "name": "Bulgarien"
    },
    "BH": {
        "name": "Bahrain"
    },
    "BI": {
        "name": "Burundi"
    },
    "BJ": {
        "name": "Benin"
    },
    "BN": {
        "name": "Brunei"
    },
    "BO": {
        "name": "Bolivia"
    },
    "BR": {
        "name": "Brasilien"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BW": {
        "name": "Botswana"
    },
    "BY": {
        "name": "Belarus"
    },
    "BZ": {
        "name": "Belize"
    },
    "CA": {
        "name": "Kanada"
    },
    "CD": {
        "name": "Kongo-Kinshasa"
    },
    "CF": {
        "name": "Centralafrikanska republiken"
    },
    "CG": {
        "name": "Kongo-Brazzaville"
    },
    "CH": {
        "name": "Schweiz"
    },
    "CI": {
        "name": "Elfenbenskusten"
    },
    "CL": {
        "name": "Chile"
    },
    "CM": {
        "name": "Kamerun"
    },
    "CN": {
        "name": "Kina"
    },
    "CO": {
        "name": "Colombia"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "CU": {
        "name": "Kuba"
    },
    "CV": {
        "name": "Kap Verde"
    },
    "CY": {
        "name": "Cypern"
    },
    "CZ": {
        "name": "Tjeckien"
    },
    "DE": {
        "name": "Tyskland"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DK": {
        "name": "Danmark"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "Dominikanska republiken"
    },
    "DZ": {
        "name": "Algeriet"
    },
    "EC": {
        "name": "Ecuador"
    },
    "EE": {
        "name": "Estland"
    },
    "EG": {
        "name": "Egypten"
    },
    "ER": {
        "name": "Eritrea"
    },
    "ES": {
        "name": "Spanien"
    },
    "ET": {
        "name": "Etiopien"
    },
    "FI": {
        "name": "Finland"
    },
    "FJ": {
        "name": "Fiji"
    },
    "FM": {
        "name": "Mikronesiska federationen"
    },
    "FR": {
        "name": "Frankrike"
    },
    "GA": {
        "name": "Gabon"
    },
    "GB": {
        "name": "Storbritannien"
    },
    "GD": {
        "name": "Grenada"
    },
    "GE": {
        "name": "Georgien"
    },
    "GH": {
        "name": "Ghana"
    },
    "GM": {
        "name": "Gambia"
    },
    "GN": {
        "name": "Guinea"
    },
    "GQ": {
        "name": "Ekvatorialguinea"
    },
    "GR": {
        "name": "Grekland"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GW": {
        "name": "Guinea-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HN": {
        "name": "Honduras"
    },
    "HR": {
        "name": "Kroatien"
    },
    "HT": {
        "name": "Haiti"
    },
    "HU": {
        "name": "Ungern"
    },
    "ID": {
        "name": "Indonesien"
    },
    "IE": {
        "name": "Irland"
    },
    "IL": {
        "name": "Israel"
    },
    "IN": {
        "name": "Indien"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Iran"
    },
    "IS": {
        "name": "Island"
    },
    "IT": {
        "name": "Italien"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JO": {
        "name": "Jordanien"
    },
    "JP": {
        "name": "Japan"
    },
    "KE": {
        "name": "Kenya"
    },
    "KG": {
        "name": "Kirgizistan"
    },
    "KH": {
        "name": "Kambodja"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KM": {
        "name": "Komorerna"
    },
    "KN": {
        "name": "Saint Kitts och Nevis"
    },
    "KP": {
        "name": "Nordkorea"
    },
    "KR": {
        "name": "Sydkorea"
    },
    "KW": {
        "name": "Kuwait"
    },
    "KZ": {
        "name": "Kazakstan"
    },
    "LA": {
        "name": "Laos"
    },
    "LB": {
        "name": "Libanon"
    },
    "LC": {
        "name": "Saint Lucia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "LR": {
        "name": "Liberia"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LT": {
        "name": "Litauen"
    },
    "LU": {
        "name": "Luxemburg"
    },
    "LV": {
        "name": "Lettland"
    },
    "LY": {
        "name": "Libyen"
    },
    "MA": {
        "name": "Marocko"
    },
    "MC": {
        "name": "Monaco"
    },
    "MD": {
        "name": "Moldavien"
    },
    "ME": {
        "name": "Montenegro"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "MH": {
        "name": "Marshallöarna"
    },
    "MK": {
        "name": "Nordmakedonien"
    },
    "ML": {
        "name": "Mali"
    },
    "MM": {
        "name": "Myanmar"
    },
    "MN": {
        "name": "Mongoliet"
    },
    "MR": {
        "name": "Mauretanien"
    },
    "MT": {
        "name": "Malta"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MV": {
        "name": "Maldiverna"
    },
    "MW": {
        "name": "Malawi"
    },
    "MX": {
        "name": "Mexiko"
    },
    "MY": {
        "name": "Malaysia"
    },
    "MZ": {
        "name": "Moçambique"
    },
    "NA": {
        "name": "Namibia"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NL": {
        "name": "Nederländerna"
    },
    "NO": {
        "name": "Norge"
    },
    "NP": {
        "name": "Nepal"
    },
    "NR": {
        "name": "Nauru"
    },
    "NZ": {
        "name": "Nya Zeeland"
    },
    "OM": {
        "name": "Oman"
    },
    "PA": {
        "name": "Panama"
    },
    "PE": {
        "name": "Peru"
    },
    "PG": {
        "name": "Papua Nya Guinea"
    },
    "PH": {
        "name": "Filippinerna"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PL": {
        "name": "Polen"
    },
    "PT": {
        "name": "Portugal"
    },
    "PW": {
        "name": "Palau"
    },
    "PY": {
        "name": "Paraguay"
    },
    "QA": {
        "name": "Qatar"
    },
    "RO": {
        "name": "Rumänien"
    },
    "RS": {
        "name": "Serbien"
    },
    "RU": {
        "name": "Ryssland"
    },
    "RW": {
        "name": "Rwanda"
    },
    "SA": {
        "name": "Saudiarabien"
    },
    "SB": {
        "name": "Salomonöarna"
    },
    "SC": {
        "name": "Seychellerna"
    },
    "SD": {
        "name": "Sudan"
    },
    "SE": {
        "name": "Sverige"
    },
    "SG": {
        "name": "Singapore"
    },
    "SI": {
        "name": "Slovenien"
    },
    "SK": {
        "name": "Slovakien"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SM": {
        "name": "San Marino"
    },
    "SN": {
        "name": "Senegal"
    },
    "SO": {
        "name": "Somalia"
    },
    "SR": {
        "name": "Surinam"
    },
    "SS": {
        "name": "Sydsudan"
    },
    "ST": {
        "name": "São Tomé och Príncipe"
    },
    "SV": {
        "name": "El Salvador"
    },
    "SY": {
        "name": "Syrien"
    },
    "SZ": {
        "name": "Swaziland"
    },
    "TD": {
        "name": "Tchad"
    },
    "TG": {
        "name": "Togo"
    },
    "TH": {
        "name": "Thailand"
    },
    "TJ": {
        "name": "Tadzjikistan"
    },
    "TL": {
        "name": "Östtimor"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "TN": {
        "name": "Tunisien"
    },
    "TO": {
        "name": "Tonga"
    },
    "TR": {
        "name": "Turkiet"
    },
    "TT": {
        "name": "Trinidad och Tobago"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "UA": {
        "name": "Ukraina"
    },
    "UG": {
        "name": "Uganda"
    },
    "US": {
        "name": "USA"
    },
    "UY": {
        "name": "Uruguay"
    },
    "UZ": {
        "name": "Uzbekistan"
    },
    "VC": {
        "name": "Saint Vincent och Grenadinerna"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnam"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "WS": {
        "name": "Samoa"
    },
    "YE": {
        "name": "Jemen"
    },
    "ZA": {
        "name": "Sydafrika"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    }
}